import CryptoJS from "crypto-js";
import { ITokenData } from "../models/ITokenData";

const key = "Mtoken";

export const encrypt = (plainText: string) =>
  CryptoJS.AES.encrypt(plainText, key).toString();

export const decrypt = (cipherText: string) =>
  CryptoJS.AES.decrypt(cipherText, key).toString(CryptoJS.enc.Utf8);

export const getWebToken = (): ITokenData | null => {
  const stToken = localStorage.getItem("MA");
  if (stToken) {
    try {
      return JSON.parse(decrypt(stToken));
    } catch {
      localStorage.removeItem("MA");
    }
  }
  return null;
};
